import ArrowRightSvg from '@/assets/ArrowRightSvg.svg';
import RobotSvg from '@/assets/RobotSvg.svg';
import DialogDesktop from '@/components/dialog/DialogDesktop.tsx';
import { DomPurifyConfig } from '@/config/DomPurify.config.ts';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import { QuizFinishedMessageProps } from '@/views/process/components/quizFinished/QuizFinishedMessageMobile.tsx';
import DOMPurify from 'dompurify';
import React from 'react';

const QuizFinishedMessageDesktop: React.FC<QuizFinishedMessageProps> = ({
  additionalMessage,
  message,
  subMessage,
}) => {
  return (
    <div className="flex gap-20 align-self-stretch align-self-md-center align-items-md-center">
      <div className="relative flex flex-col justify-center">
        <DialogDesktop
          arrow={
            <img
              alt="arrow-right"
              className="absolute -z-10 -right-14 bottom-1/4 transform -translate-y-1/2"
              src={ArrowRightSvg}
            />
          }
          content={
            <>
              <p
                className="body"
                dangerouslySetInnerHTML={{
                  __html: subMessage ? DOMPurify.sanitize(subMessage, DomPurifyConfig) : '',
                }}
              />
              {additionalMessage && <p className="body mt-3">{additionalMessage}</p>}
            </>
          }
          message={message}
        />
      </div>
      <div className="-mt-24">
        <img alt="robot" className="w-full" src={generateNonCachableImageSrc(RobotSvg)} />
      </div>
    </div>
  );
};

export default QuizFinishedMessageDesktop;
